import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const useHealthlinkPracticeCredentials = () => {
  const tenant =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const fetchHealthlinkPracticeCredentials = async () => {
    const axiosInstance = createAxiosInstance();

    try {
      const response = await axiosInstance.get(
        `${tenant}/healthlink/credentials/practice`
      );

      return response.data;
    } catch (error) {
      // A tenant may have no HealthLink practice credentials configured. That
      // is a valid state, not an error — return an empty list so consumers
      // degrade gracefully instead of surfacing a global error toast.
      if (error?.response?.status === 404) {
        return [];
      }

      throw error;
    }
  };

  return useQuery({
    queryKey: ["healthlinkPracticeCredentials", tenant],
    queryFn: fetchHealthlinkPracticeCredentials,
    enabled: !!tenant,
    meta: { skipGlobalError: true },
  });
};

export { useHealthlinkPracticeCredentials };